const googlemapSave = payload => {
  return {
    type: "googlemapbase64",
    payload
  };
};

export default googlemapSave;
